export default {
    error: false,
    loading: {
        module:false,
    },
    message_loading : 'Cargando Plantilla De Incorporación De Productos',
    file: ''
};



// WEBPACK FOOTER //
// ./src/modules/import-products/state.js